export interface Conversation {
    id: string;
}
